module.exports = __webpack_public_path__ + "static/media/waveBackground.69fab639.jpg";